<template>
    <hts-drawer
        v-model="visible"
        :rules="ruleAddCustomer"
        :submit="visibleSubmit"
        :title="$t('labels.partnerAdd')"
        no-reset
        size="large"
        @close="closeOverSide">
        <hts-card :title="$t('labels.generalInformation')">
            <hts-form-input
                v-model="dataFormAddCustomer.name"
                :label="$t('labels.companyName')"
                required
                :color="props.color"
                name="companyName"
                prop="name" />
            <div class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-input
                    v-model="dataFormAddCustomer.abbreviationName"
                    :label="$t('labels.abbreviationName')"
                    required
                    :color="props.color"
                    name="abbreviationName"
                    prop="abbreviationName" />
                <hts-form-input
                    v-model="dataFormAddCustomer.taxNumber"
                    :label="$t('labels.taxNumber')"
                    :color="props.color"
                    name="taxNumber"
                    prop="taxNumber"
                    required />
                <hts-form-input
                    v-model="dataFormAddCustomer.email"
                    :label="$t('labels.email')"
                    :color="props.color"
                    name="email"
                    prop="email"
                    required />
                <hts-form-phone
                    v-model="dataFormAddCustomer.phone"
                    :label="$t('labels.phone')"
                    required
                    prop="phone"
                    name="phone"
                    @updateCode="(val) => (dataFormAddCustomer.phone.code = val)" />
                <hts-form-input
                    v-model="dataFormAddCustomer.representation"
                    :label="$t('labels.representation')"
                    required
                    :color="props.color"
                    name="representation"
                    prop="representation" />
                <hts-form-input
                    v-model="dataFormAddCustomer.office"
                    required
                    :label="$t('labels.office')"
                    :color="props.color"
                    name="office"
                    prop="office" />
                <hts-form-input
                    v-model="dataFormAddCustomer.website"
                    :label="$t('labels.website')"
                    :color="props.color"
                    name="website"
                    prop="website" />

                <hts-form-input
                    v-model="dataFormAddCustomer.fax"
                    :label="$t('labels.fax')"
                    :color="props.color"
                    name="fax"
                    prop="fax" />
                <hts-form-input
                    v-model="dataFormAddCustomer.address"
                    :label="$t('labels.address')"
                    :color="props.color"
                    required
                    name="address"
                    prop="address"
                    @change="setDefaultDataPostionByAddress" />
                <hts-form-input
                    v-model="dataFormAddCustomer.locationName"
                    :label="$t('labels.location')"
                    :color="props.color"
                    name="location"
                    prop="location"
                    required
                    autocomplete="off"
                    @click="openModalLocation" />
            </div>
        </hts-card>
        <hts-card :title="$t('labels.typeCustomer')">
            <div>
                <hts-form-checkbox
                    v-model="dataFormAddCustomer.type"
                    :label="$t('labels.typeCustomer')"
                    :items="selectCooperatorTypes"
                    required
                    prop="typeCustomer"
                    name="typeCustomer" />
            </div>
            <hts-form-button-group
                v-if="customerTypeTabs && customerTypeTabs.length"
                v-model="selectCustomerTypeTabs"
                :items="customerTypeTabs"
                type="button"
                class="my-5" />
            <div
                v-if="dataFormAddCustomer.type?.includes('CUSTOMER') && selectCustomerTypeTabs"
                v-show="selectCustomerTypeTabs === 'CUSTOMER'"
                class="grid gap-4 grid-cols-1 sm:grid-cols-2">
                <hts-form-input
                    v-model="dataFormAddCustomer.markup"
                    :label="$t('labels.markupPercent')"
                    :color="props.color"
                    type="number"
                    name="markupPercent"
                    prop="markup" />
                <hts-form-input
                    v-model="dataFormAddCustomer.commission"
                    type="number"
                    :label="$t('labels.commission2')"
                    :color="props.color"
                    name="commission2"
                    prop="commission2" />
                <hts-select-user
                    v-model="dataFormAddCustomer.curator"
                    v-model:name="dataFormAddCustomer.curatorName"
                    :label="$t('labels.curator')"
                    required
                    group-type="business"
                    prop="curator" />
                <hts-select-user
                    v-model="dataFormAddCustomer.distribution"
                    v-model:name="dataFormAddCustomer.distributionName"
                    :label="$t('labels.abstemious')"
                    required
                    group-type="distribution"
                    prop="abstemious" />
            </div>

            <div
                v-if="dataFormAddCustomer.type?.includes('PARTNER') && selectCustomerTypeTabs"
                v-show="selectCustomerTypeTabs === 'PARTNER'">
                <span class="text-base block px-0 font-medium text-default-500">
                    {{ $t('labels.moocSavingPolicy') }}
                </span>
                <div class="pl-10 grid gap-4 grid-cols-1 sm:grid-cols-2">
                    <hts-form-input
                        v-model="dataFormAddCustomer.moocSavingPolicy.freeHourNumber"
                        :label="$t('labels.freeHourNumber')"
                        type="number"
                        :color="props.color"
                        name="keepMoocByHours"
                        prop="keepMoocByHours" />
                    <hts-form-input
                        v-model="dataFormAddCustomer.moocSavingPolicy.moocKeepHourly"
                        :label="$t('labels.moocKeepHourly')"
                        type="number"
                        :color="props.color"
                        name="moocKeepHourly"
                        prop="moocKeepHourly" />
                    <hts-form-input
                        v-model="dataFormAddCustomer.moocSavingPolicy.moocKeepOvernight"
                        :label="$t('labels.moocKeepOvernight')"
                        type="number"
                        :color="props.color"
                        name="moocKeepOvernight"
                        prop="moocKeepOvernight" />
                    <hts-form-date
                        v-model="dataFormAddCustomer.moocSavingPolicy.calculatedByHourNextDay"
                        :label="$t('labels.calculatedByHourNextDay')"
                        type="time"
                        :color="props.color"
                        name="calculatedByHourNextDay"
                        prop="calculatedByHourNextDay" />

                    <hts-form-input
                        v-model="dataFormAddCustomer.moocSavingPolicy.moocKeepLongTerm"
                        :label="$t('labels.moocKeepLongTerm')"
                        type="number"
                        :color="props.color"
                        name="moocKeepLongTerm"
                        prop="moocKeepLongTerm" />
                    <hts-form-input
                        v-model="dataFormAddCustomer.moocSavingPolicy.calculatedFromEvening"
                        :label="$t('labels.moocKeepLongTermCalculatedFromEvening')"
                        type="number"
                        :color="props.color"
                        name="calculatedFromEvening"
                        prop="calculatedFromEvening" />
                </div>
                <span class="text-base block px-0 font-medium text-default-500">
                    {{ $t('labels.holidaySurchargePolicy') }}
                </span>
                <div class="pl-10 grid gap-4 grid-cols-1 sm:grid-cols-2">
                    <hts-form-input
                        v-model="dataFormAddCustomer.otherSurchargePolicy.towingContainerSunday"
                        :label="$t('labels.towingContainerSunday')"
                        type="number"
                        :color="props.color"
                        name="towingContainerSunday"
                        prop="towingContainerSunday" />
                    <hts-form-input
                        v-model="dataFormAddCustomer.otherSurchargePolicy.towingContainerHoliday"
                        :label="$t('labels.towingContainerHoliday')"
                        type="number"
                        :color="props.color"
                        name="towingContainerHoliday"
                        prop="towingContainerHoliday" />
                </div>
                <span class="text-base block px-0 font-medium text-default-500">
                    {{ $t('labels.reeferPluginCharges') }}
                </span>
                <div class="pl-10 grid gap-4 grid-cols-1 sm:grid-cols-2">
                    <hts-form-input
                        v-model="dataFormAddCustomer.reeferPluginCharges.reeferPluginChargesGenerator"
                        :label="$t('labels.reeferPluginChargesGenerator')"
                        type="number"
                        :color="props.color"
                        name="reeferPluginChargesGenerator"
                        prop="reeferPluginChargesGenerator" />
                </div>
            </div>
        </hts-card>

        <div
            v-if="dataFormAddCustomer.type?.includes('PARTNER') && selectCustomerTypeTabs"
            class="my-5">
            <!--
              <hts-form-toggle
              v-model="dataFormAddCustomer.isSendMail"
              :label="$t('labels.isSendEmail')"
              color="primary"
              label-right />
              <hts-form-input
              v-if="dataFormAddCustomer.isSendMail"
              v-model="dataFormAddCustomer.emailInvite"
              :label="$t('labels.emailInvite')"
              required
              :color="props.color"
              name="emailInvite"
              prop="emailInvite"
              @change="emailInviteError = ''" />
              <p
              v-if="emailInviteError && dataFormAddCustomer.isSendMail"
              class="text-error-500 text-xs pl-2 pt-1">
              {{ emailInviteError }}
              </p>
            -->
        </div>

        <hts-modal
            :show="showConfirmCreateCooperator"
            :title="$t('labels.confirmMarkup')"
            type="confirm"
            :content="contentConfirmMarkup"
            @hide="showConfirmCreateCooperator = false"
            @confirm="handleSubmitFormAddCustomer" />
        <hts-modal
            :show="showLocation"
            :title="$t('labels.locationInformation')"
            @hide="showLocation = false">
            <template #custom>
                <hts-map-autocomplete
                    :label="$t('labels.findPosition')"
                    :required="true"
                    :placeholder="$t('labels.nodeModule.search')"
                    @get-place-detail="(data:any)=>handleSetPosition(data)" />
                <hts-form-input
                    v-model="dataFormAddCustomer.locationName"
                    :label="$t('labels.location')"
                    :color="props.color"
                    :suffix="false"
                    required
                    disabled
                    name="location"
                    prop="location" />
                <hts-map-node
                    :center-position="dataPostion"
                    center-marker
                    @click="getLocationMap" />
            </template>
        </hts-modal>
        <hts-modal
            :show="showAcceptChangeTypeCooperator"
            :title="titleAcceptChangeTypeCooperator"
            type="confirm"
            :content="detailAcceptChangeTypeCooperator"
            @hide="cancelAcceptChangeTypeCooperator"
            @confirm="handleAcceptChangeTypeCooperator" />
    </hts-drawer>
</template>

<script setup lang="ts">
import form, { IAddCooperator } from './imports/form'
import layoutPermissions from '@/data/permissions/layout-permissions'

const { $t } = useNuxtApp()
const store = $store()

const showConfirmCreateCooperator = ref(false)
const showLocation = ref(false)
const emailInviteError = ref('')

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  }
})
const emits = defineEmits(['close', 'refreshTables', 'newPartner'])

const closeOverSide = () => {
  visible.value = false
  undo()
}
const visible = ref(false)
const isSelectType = ref(true)

const open = (types?: string | [string]) => {
  const whiteList = ['VENDOR', 'PARTNER', 'CUSTOMER']
  visible.value = true
  dataFormAddCustomer.type = []
  dataFormAddCustomer.phone = {
    countryCode: 'Vietnam +84',
    phone: '',
    code: '+84'
  }

  if (!types || !types.length) {
    return null
  }
  if (typeof types === 'string' && whiteList.includes(types)) {
    isSelectType.value = false
    dataFormAddCustomer.type = [types]
  }

  if (Array.isArray(types)) {
    const checkType = types.map((type: string) => {
      return whiteList.includes(type)
    })
    if (checkType.includes(false)) {
      return null
    }
    isSelectType.value = false
    dataFormAddCustomer.type = types
  }
}
defineExpose({
  open
})

const dataFormAddCustomer = reactive<IAddCooperator>({
  name: '',
  abbreviationName: '',
  taxNumber: '',
  email: '',
  emailInvite: '',
  website: '',
  address: '',
  fax: '',
  phone: {
    countryCode: '',
    phone: '',
    code: ''
  },
  office: '',
  representation: '',
  commission: null,
  isSendMail: false,
  markup: null,
  emailConfirmMarkup: '',
  type: [],
  curator: '',
  curatorName: '',
  distribution: '',
  distributionName: '',
  locationName: '',
  location: null,
  moocSavingPolicy: {
    freeHourNumber: null,
    moocKeepHourly: null,
    moocKeepOvernight: null,
    calculatedByHourNextDay: null,
    moocKeepLongTerm: null,
    calculatedFromEvening: null
  },
  otherSurchargePolicy: {
    towingContainerSunday: null,
    towingContainerHoliday: null
  },
  reeferPluginCharges: {
    reeferPluginChargesGenerator: null
  }
})

const undo = () => {
  Object.assign(typeCooperator, typeCooperatorDefault)
  dataPostion.value = {
    lat: 10.7561542,
    lng: 106.6896784
  }
  Object.assign(dataFormAddCustomer, {
    name: '',
    taxNumber: '',
    email: '',
    website: '',
    address: '',
    fax: '',
    phone: {
      countryCode: '',
      phone: '',
      code: ''
    },
    office: '',
    representation: '',
    commission: null,
    isSendMail: false,
    markup: null,
    curator: '',
    curatorName: '',
    distribution: '',
    distributionName: '',
    locationName: '',
    location: null,
    emailInvite: null,
    type: null
  })
  dataFormAddCustomer.moocSavingPolicy = {
    freeHourNumber: null,
    moocKeepHourly: null,
    moocKeepOvernight: null,
    calculatedByHourNextDay: null,
    moocKeepLongTerm: null,
    calculatedFromEvening: null
  }
  dataFormAddCustomer.otherSurchargePolicy = {
    towingContainerSunday: null,
    towingContainerHoliday: null
  }
  dataFormAddCustomer.reeferPluginCharges = {
    reeferPluginChargesGenerator: null
  }
}

const openModalLocation = () => {
  showLocation.value = true
}

const valueMarkupSetting = computed(() => store.globalSettings.getGlobalSettings.markup)

const visibleSubmit = async () => {
  if (dataFormAddCustomer.type?.includes('CUSTOMER') && dataFormAddCustomer.markup && dataFormAddCustomer.markup < (valueMarkupSetting.value || 0)) {
    showConfirmCreateCooperator.value = true
  } else {
    await handleSubmitFormAddCustomer()
  }
}

const typeCooperatorDefault = {
  CUSTOMER: [],
  PARTNER: false,
  VENDOR: false
}

const typeCooperator = reactive({ ...typeCooperatorDefault })

const handleSubmitFormAddCustomer = () => {
  const api = $urlClient.partner['partner-add']
  dataFormAddCustomer.location = dataPostion.value
  $api(api, { body: dataFormAddCustomer }).then((data) => {
    const resData: any = data?.data?.value
    showConfirmCreateCooperator.value = false

    if (resData?.success) {
      if (resData.data.code === 1) {
        emailInviteError.value = $t('labels.emailJoinedSystem')
        return
      }

      emits('newPartner', resData?.data)
      undo()
      emits('refreshTables')
      process.client && $toast().success($t('labels.addSuccess', { name: $t('labels.company') }))
      visible.value = false
    }
  })
}

const dataPostion = ref<{ lat: number; lng: number } | null>({
  lat: 10.7561542,
  lng: 106.6896784
})

const handleSetPosition = (data: any) => {
  dataFormAddCustomer.locationName = data.formatted_address
  dataPostion.value = {
    lat: data.geometry.location.lat(),
    lng: data.geometry.location.lng()
  }
}
const getLocationMap = (data: any) => {
  const geocoder = new google.maps.Geocoder()
  geocoder.geocode({ location: data }).then((result) => {
    const { results } = result
    dataFormAddCustomer.locationName = results[0].formatted_address
    dataPostion.value = {
      lat: results[0].geometry.location.lat(),
      lng: results[0].geometry.location.lng()
    }
  })
}

const selectCooperatorTypes = [
  // {
  //   label: $t('labels.customer'),
  //   value: 'CUSTOMER'
  // },
  {
    label: $t('labels.partner'),
    value: 'PARTNER'
  }
  // {
  //   label: $t('labels.vendor'),
  //   value: 'VENDOR'
  // }
]

const showAcceptChangeTypeCooperator = ref(false)
const titleAcceptChangeTypeCooperator = ref('')
const detailAcceptChangeTypeCooperator = ref('')
const handleAcceptChangeTypeCooperator: any = ref()
const cancelAcceptChangeTypeCooperator: any = ref()

watch(
  () => ({ ...dataFormAddCustomer.type }),
  (newVal, oldVal) => {
    if (!visible.value) {
      return
    }

    if (Object.values(oldVal).includes('CUSTOMER') && !Object.values(newVal).includes('CUSTOMER')) {
      titleAcceptChangeTypeCooperator.value = $t('labels.titleAcceptChangeTypeCustomer')
      detailAcceptChangeTypeCooperator.value = $t('labels.detailAcceptChangeTypeCustomer')
      handleAcceptChangeTypeCooperator.value = () => handleChangeCheckboxCooperatorTypeCustomer(false)
      cancelAcceptChangeTypeCooperator.value = () => cancelChangeTypeCooperator('CUSTOMER')
      showAcceptChangeTypeCooperator.value = true
      return
    }

    if (Object.values(oldVal).includes('PARTNER') && !Object.values(newVal).includes('PARTNER')) {
      titleAcceptChangeTypeCooperator.value = $t('labels.titleAcceptChangeTypePartner')
      detailAcceptChangeTypeCooperator.value = $t('labels.detailAcceptChangeTypePartner')
      handleAcceptChangeTypeCooperator.value = () => handleChangeCheckboxCooperatorTypePartner(false)
      cancelAcceptChangeTypeCooperator.value = () => cancelChangeTypeCooperator('PARTNER')
      showAcceptChangeTypeCooperator.value = true
    }
  },
  { deep: true }
)

const cancelChangeTypeCooperator = (type: string) => {
  if (dataFormAddCustomer.type?.includes(type)) {
    return
  }

  if (type === 'CUSTOMER') {
    dataFormAddCustomer.type?.push(type)
  }

  if (type === 'PARTNER') {
    dataFormAddCustomer.type?.push(type)
  }

  showAcceptChangeTypeCooperator.value = false
}

const handleChangeCheckboxCooperatorTypeCustomer = (val: boolean) => {
  if (typeof val === 'boolean') {
    showAcceptChangeTypeCooperator.value = false
    if (val && !dataFormAddCustomer.type?.includes('CUSTOMER')) {
      dataFormAddCustomer.type?.push('CUSTOMER')
      dataFormAddCustomer.markup = store.globalSettings.getGlobalSettings.markup || 0
    }
    if (!val && dataFormAddCustomer?.type) {
      $lodash.remove(dataFormAddCustomer.type, (i) => {
        return i === 'CUSTOMER'
      })
      dataFormAddCustomer.markup = null
      dataFormAddCustomer.commission = null
      dataFormAddCustomer.curator = ''
      dataFormAddCustomer.curatorName = ''
      dataFormAddCustomer.distribution = ''
      dataFormAddCustomer.distributionName = ''
    }
  }
}
const handleChangeCheckboxCooperatorTypePartner = (val: boolean) => {
  if (typeof val === 'boolean') {
    showAcceptChangeTypeCooperator.value = false
    if (val && !dataFormAddCustomer.type?.includes('PARTNER')) {
      dataFormAddCustomer.type?.push('PARTNER')
    }
    if (!val && dataFormAddCustomer?.type) {
      $lodash.remove(dataFormAddCustomer.type, (i) => {
        return i === 'PARTNER'
      })

      dataFormAddCustomer.moocSavingPolicy = {
        freeHourNumber: null,
        moocKeepHourly: null,
        moocKeepOvernight: null,
        calculatedByHourNextDay: null,
        moocKeepLongTerm: null,
        calculatedFromEvening: null
      }
      dataFormAddCustomer.otherSurchargePolicy = {
        towingContainerSunday: null,
        towingContainerHoliday: null
      }
      dataFormAddCustomer.reeferPluginCharges = {
        reeferPluginChargesGenerator: null
      }

      dataFormAddCustomer.isSendMail = false
      dataFormAddCustomer.emailInvite = null
    }
  }
}

const ruleAddCustomer = computed(() => {
  const result = { ...form.rulesCustomer }
  if (dataFormAddCustomer.locationName && dataFormAddCustomer.locationName.search('Việt Nam') !== -1) {
    result.taxNumber = 'required|regexTaxNumber'
  }
  return result
})

const customerTypeTabs = computed(() => {
  const tabs: any = []
  const keyTypes: any = []
  if (dataFormAddCustomer.type?.includes('CUSTOMER')) {
    tabs.push({
      id: 'CUSTOMER',
      label: $t('labels.customer')
    })
    keyTypes.push('CUSTOMER')
  }

  if (dataFormAddCustomer.type?.includes('PARTNER')) {
    tabs.push({
      id: 'PARTNER',
      label: $t('labels.partner')
    })
    keyTypes.push('PARTNER')
  }

  if (!keyTypes.length) {
    selectCustomerTypeTabs.value = ''
  } else if (!keyTypes.includes(selectCustomerTypeTabs.value)) {
    selectCustomerTypeTabs.value = keyTypes[0]
  }

  return tabs
})

const selectCustomerTypeTabs = ref('')

const setDefaultDataPostionByAddress = $lodash.debounce(() => {
  const geocoder = new google.maps.Geocoder()
  const address = dataFormAddCustomer.address
  geocoder.geocode({ address }, function (results, status) {
    if (status === 'OK') {
      if (results && results.length > 0) {
        const location = results[0].geometry.location
        dataPostion.value = {
          lat: location.lat(),
          lng: location.lng()
        }
        dataFormAddCustomer.locationName = results[0].formatted_address
      }
    }
  })
}, 500)

const contentConfirmMarkup = computed(() => {
  //  label confirm markup
  if (checkPermission(layoutPermissions.partner_confirm_status_markup)) {
    return `Markup được nhập có giá trị nhỏ hơn giá trị được cài đặt cho toàn hệ thống ${valueMarkupSetting.value}%. Bạn có muốn tiếp tục?`
  } else {
    return `Markup được nhập có giá trị nhỏ hơn giá trị được cài đặt cho toàn hệ thống ${valueMarkupSetting.value}%. Vui lòng chờ phê duyệt từ bộ phận quản lý.`
  }
})
</script>
